type SectionLabelProps = {
  children: React.ReactNode;
  align?: "left" | "center";
  tone?: "dark" | "light";
};

// Red-dot eyebrow label used above every section heading on the business page.
export const SectionLabel = ({ children, align = "center", tone = "dark" }: SectionLabelProps) => (
  <div
    className={`flex items-center gap-[12px] ${align === "center" ? "justify-center" : "justify-start"} ${
      tone === "light" ? "text-white" : "text-[#2A2A2A]"
    }`}
  >
    <span className="w-[14px] h-[14px] md:w-[18px] md:h-[18px] rounded-full bg-[#D90000] shadow-[0_0_8px_rgba(217,0,0,0.45)]" />
    <span className="text-[15px] md:text-[20px] leading-none">{children}</span>
  </div>
);
